<template>
  <el-tooltip
    effect="dark"
    :content="'用户：' + userInfo.name"
    placement="bottom"
  >
    <el-image
      :style="{
        width: error ? '42px' : '40px',
        height: error ? '42px' : '40px',
        'margin-right': '10px',
        'border-radius': '100px',
        border: error ? '' : '1px solid ' + $jsTool.getColor('primary'),
      }"
      fit="cover"
      @error="error = true"
      :src="
        userInfo.avatar
          ? userInfo.avatar.prefix + userInfo.avatar.name
          : 'null'
      "
    >
      <div
        slot="error"
        :style="{
          height: '100%',
          'background-color': $jsTool.getColor('primary'),
          color: '#ffffff',
        }"
        class="fm-center"
      >
        {{ subName }}
      </div>
    </el-image>
  </el-tooltip>
</template>

<script>
export default {
  name: "Fmerpv2WebUserAvatar",
  props: {
    userInfo: {
      type: Object,
      default: null,
    },
    nameLength: {
      type: [String, Number],
      default: 2,
    },
  },
  computed: {
    subName() {
      if (this.userInfo.name) {
        if (this.userInfo.name.length < this.nameLength) {
          return this.userInfo.name;
        } else {
          return this.userInfo.name.substring(
            this.userInfo.name.length - this.nameLength,
            this.userInfo.name.length
          );
        }
      }
    },
  },
  data() {
    return {
      error: false,
    };
  },

  mounted() {},

  methods: {},
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/UserAvatar.vue